/**
 * Studio Project API Client
 * Handles orchestration API calls for creating complete project structures
 */

import { BaseApiClient, ApiResponse } from './baseApiClient';
import { API_ENDPOINTS } from '../config/apiEndpoints';
import {
  CreateProjectWithStructureRequest,
  CreateProjectWithStructureResponse,
} from '../types/studioProject.types';

/**
 * Studio Project API Client
 */
export class StudioProjectApiClient extends BaseApiClient {
  /**
   * Create a complete project structure (Project, App, Process, ProcessThread)
   */
  async createWithStructure(
    request: CreateProjectWithStructureRequest
  ): Promise<ApiResponse<CreateProjectWithStructureResponse>> {
    return this.post<CreateProjectWithStructureResponse>(
      API_ENDPOINTS.STUDIO_PROJECTS.CREATE_WITH_STRUCTURE,
      request
    );
  }
}

// Singleton instance
export const studioProjectApiClient = new StudioProjectApiClient();
